import axiosFetch from './config';


export const getContactInfo = async () => {
    let token = await localStorage.getItem('token');
    return axiosFetch({
      method: 'GET',
      url: `/contactInfo`,
      headers: {
        Authorization: 'Bearer ' + token,
    },
    })
}

export const phoneOtpSend = async (phone) => {
    let token = await localStorage.getItem('token');
    return axiosFetch({
      method: 'POST',
      url: `/contactInfo/otp/send`,
      data: {
        typeOfContactId: 'PHONE',
        contact: phone,
      },
      headers: {
        Authorization: 'Bearer ' + token,
    },
    })
}

export const emailOtpSend = async (email) => {
    let token = await localStorage.getItem('token');
    return axiosFetch({
      method: 'POST',
      url: `/contactInfo/otp/send`,
      data: {
        typeOfContactId: "MAIL",
        contact: email,
      },
      headers: {
        Authorization: 'Bearer ' + token,
    },
    })
}


export const postContact = async (data) => {
    let token = await localStorage.getItem('token');
    return axiosFetch({
      method: 'POST',
      data,
      url: `/contactInfo`,
      headers: {
        Authorization: 'Bearer ' + token,
    },
    })
}

export const putContact = async(id,data)=>{
    let token = await localStorage.getItem('token')
    return axiosFetch({
      method:'PUT',
      data,
      url: `/contactInfo/${id}`, 
      headers: {
        Authorization: 'Bearer ' + token,
      }
    })
}

export const deleteContactInfoById = async(id)=>{
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method:'DELETE',
    url: `/contactInfo/${id}`, 
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}